import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import {
  cloudAgentsRouteRef as rootRouteRef,
  CloudAgentsClient,
  cloudAgentsApiRef,
} from '@internal/plugin-cloud-agents-react';

const cloudAgentsApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: cloudAgentsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new CloudAgentsClient({ discoveryApi, fetchApi, identityApi }),
    }),
});

const cloudAgentsPage = PageBlueprint.make({
  params: {
    path: '/cloud-agents',
    title: 'Cloud Agents',
    routeRef: rootRouteRef,
    // The list and run detail pages render their own PluginHeader and Header.
    noHeader: true,
    loader: () =>
      import('./components/CloudAgentsPage').then(m => <m.CloudAgentsPage />),
  },
});

export const cloudAgentsPlugin = createFrontendPlugin({
  pluginId: 'cloud-agents',
  title: 'Cloud Agents',
  routes: {
    root: rootRouteRef,
  },
  extensions: [cloudAgentsApi, cloudAgentsPage],
});

export default cloudAgentsPlugin;
